import React from 'react';
import styled from 'styled-components';
import { Container, Heading1 } from '../components/common';
import { DealCard } from '../components/Deals/DealCard';
import { SeoTags } from '../components/SeoTags';
import { media } from '../utils/styles';

const DealsPage = ({ pageContext: { heading, products } }) => {
  return (
    <>
      <SeoTags title="Deals" />
      <Hero>
        <Container>
          <Heading>{heading}</Heading>
        </Container>
      </Hero>
      <Container>
        <Grid>
          {products.map(product => (
            <DealCard key={product.uid} product={product} />
          ))}
        </Grid>
      </Container>
    </>
  );
};

const Heading = styled(Heading1)`
  text-align: left;
`;

const Grid = styled.div`
  padding: 180px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  ${media.tablet} {
    padding: 100px 0;
    justify-content: center;
    grid-template-columns: 450px;
  }
  ${media.phone} {
    grid-template-columns: 1fr;
    padding: 60px 0;
  }
`;

const Hero = styled.div`
  background: linear-gradient(90deg, #ff5748 0%, #ff9ed8 100%);
  padding: 260px 0;
  ${media.tablet} {
    padding: 200px 0;
  }
`;

export default DealsPage;
